import { Kefir as K } from "kefir";
import { forEach } from "ramda";
import { queryChild } from "@standard-library/q-prime";

function Video($videos) {
  const sizers = $videos.map(function() {
    if (jQuery(this).data("letterboxed")) {
      return new LetterboxSizer(this);
    } else {
      return new VideoSizer(this);
    }
  });

  const players = $videos.map(function() {
    const $iframe = jQuery(this).find("iframe");

    if ($iframe.length) {
      return new Vimeo.Player($iframe);
    } else {
      return new NativePlayer(queryChild(this, "video"));
    }
  });

  forEach(call("resize"), sizers);

  jQuery(window).on("resize.videos", function() {
    forEach(call("resize"), sizers);
  });

  forEach(function(player) {
    const $video = jQuery(player.element).closest(".video-player");
    const $progress = jQuery(`<div class="video-player__progress-bar">`);

    $video.addClass("is-loading");
    $video.append($progress);

    const loaded = K.merge([
      // Vimeo videos
      K.fromEvents(player, "loaded"),
      // Native videos
      K.fromEvents(player, "canplay"),
      K.later(1, true).filter(() => player.element.readyState === 4)
    ]);

    const play = K.fromEvents(player, "play");
    const pause = K.fromEvents(player, "pause");

    const playerClick = K.fromEvents($video, "click");

    const timeUpdate = K.fromEvents(player, "timeupdate").throttle(250);
    const progress = timeUpdate.map(e => {
      return e.percent || e.target.currentTime / e.target.duration;
    });

    progress.observe(percent => {
      $progress.css({
        width: `${percent * 100}%`
      });
    });

    play.observe(() => $video.addClass("is-playing"));
    pause.observe(() => $video.removeClass("is-playing"));

    play.observe(() => {
      const $hero = $video.parents(".hero");
      const $text = $hero.siblings(".hero-text");

      setTimeout(() => {
        $hero.addClass("color");
        $text.addClass("is-deactivated");
      }, 1500);
    });

    const pauseRequested = playerClick.scan(p => !p, false);

    playerClick.observe(() => {
      if (player.paused) {
        player.play();
      } else {
        player.pause();
      }
    });

    loaded.observe(() => {
      const playButton = $video.find(".video-block__play");

      setTimeout(function() {
        $video.removeClass("is-loading").addClass("is-loaded");
      }, 1000);

      setTimeout(function() {
        player.element.play();
      }, 500);

      const $document = jQuery(document);
      const scrollY = K.fromEvents($document, "scroll", () =>
        $document.scrollTop()
      );

      K.combine([scrollY, pauseRequested]).observe(([y, remainPaused]) => {
        if (y > window.innerHeight && !player.element.paused) {
          player.element.pause();
        } else if (
          y < window.innerHeight &&
          player.element.paused &&
          !remainPaused
        ) {
          player.element.play();
        }
      });
    });
  }, players);
}

function VideoSizer(el) {
  this.$el = jQuery(el);
  this.$wrapper = this.$el.find(".video-wrapper");
  this.$iframe = this.$el.find("iframe, video");

  this.width = parseInt(this.$iframe.attr("width"));
  this.height = parseInt(this.$iframe.attr("height"));
  this.ratio = this.height / this.width;
}

VideoSizer.prototype.resize = function() {
  const w = new Window();
  const isTooShort = w.ratio > this.ratio;

  if (isTooShort) {
    var height = w.height;
    var width = height / this.ratio;
  } else {
    var width = w.width;
    var height = width * this.ratio;
  }

  this.$wrapper.css({
    width: width,
    height: height * 2,
    top: (w.height - height * 2) / 2,
    left: (w.width - width) / 2
  });
};

function Window() {
  this.$window = jQuery(window);
  this.height = this.$window.height();
  this.width = this.$window.width();
  this.ratio = this.height / this.width;
}

function call(method) {
  return x => x[method]();
}

class NativePlayer {
  constructor(element) {
    this.element = element;
  }

  addEventListener() {
    this.element.addEventListener(...arguments);
  }

  removeEventListener() {
    this.element.removeEventListener(...arguments);
  }

  play() {
    this.element.play();
  }

  pause() {
    this.element.pause();
  }

  get paused() {
    return this.element.paused;
  }
}

class LetterboxSizer {
  constructor(element) {
    this.$el = jQuery(element);
    this.$wrapper = this.$el.find(".video-wrapper");
    this.$iframe = this.$el.find("iframe, video");

    this.width = parseInt(this.$iframe.attr("width"));
    this.height = parseInt(this.$iframe.attr("height"));
    this.ratio = this.height / this.width;
  }

  resize() {
    const w = {
      width: this.$el.width(),
      height: this.$el.height(),
      ratio: this.$el.height() / this.$el.width()
    };
    const isTooShort = w.ratio > this.ratio;

    if (isTooShort) {
      var width = w.width;
      var height = height / this.ratio;
    } else {
      var width = w.height / this.ratio;
      var height = width * 2;
    }

    this.$wrapper.css({
      width: width,
      height: height,
      top: (w.height - height) / 2,
      left: (w.width - width) / 2
    });
  }
}

function NullSizer() {}

NullSizer.prototype.resize = function() {};

export default Video;



// WEBPACK FOOTER //
// ./app/javascript/modules/video.js